import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Simple scroll-into-view reveal
export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

// Masked line reveal — wrap each line in overflow-hidden and slide up
export const MaskedLines = ({ lines, className = "", lineClassName = "", stagger = 0.12, delay = 0.1 }) => (
  <div className={className}>
    {lines.map((line, i) => (
      <div key={i} className="overflow-hidden">
        <motion.div
          className={lineClassName}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.9, delay: delay + i * stagger, ease: EASE }}
        >
          {line}
        </motion.div>
      </div>
    ))}
  </div>
);

export { EASE };
